/* schedule.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" xml:space="preserve">
        <path class="foreground-gl" d="M18.9,2.69H17.42v.67s0,.06,0,.09a2.32,2.32,0,0,1-4.64-.09V2.69H7.07v.67s0,.06,0,.09a2.32,2.32,0,0,1-4.64-.09V2.69H1.14a1,1,0,0,0-1,1V6.36H19.93V3.72A1,1,0,0,0,18.9,2.69Z" transform="translate(-0.11 -0.07)"/>
        <path class="foreground-gl" d="M4.72,4.75A1.43,1.43,0,0,1,3.29,3.32V1.5a1.43,1.43,0,1,1,2.86,0V3.32A1.43,1.43,0,0,1,4.72,4.75Z" transform="translate(-0.11 -0.07)"/>
        <path class="foreground-gl" d="M15.13,4.75A1.43,1.43,0,0,1,13.7,3.32V1.5a1.43,1.43,0,1,1,2.86,0V3.32A1.43,1.43,0,0,1,15.13,4.75Z" transform="translate(-0.11 -0.07)"/>
        <path class="foreground-gl" d="M10.72,19.94h8.17a1.08,1.08,0,0,0,1.08-1v-11H.11v11a1,1,0,0,0,1,1Z" transform="translate(-0.11 -0.07)"/>
        </svg> 
    `
};
